export default __webpack_public_path__ + "static/media/Amazon.8d255cb0.svg";